import * as React from 'react';

import './style.scss';
import Block from '../Block';
import ProfileImage from '../../assets/images/profile-fallback-image.svg';

type HighlightedProfileProps = {
  picture?: React.ReactNode
  name: string
  info?: string
  email?: string
  tel?: string
};

const HighlightedProfile: React.FC<HighlightedProfileProps> = (props) => {
  const {
    picture,
    name,
    info,
    email,
    tel,
  } = props;

  return (
    <div className="HighlightedProfile">
      <div className="HighlightedProfile__picture">
        {picture || (
          <img src={ProfileImage} alt="" />
        )}
      </div>
      <div className="HighlightedProfile__info">
        <div className="asH4">{name}</div>
        {info && <span>{info}</span>}
        {email && <div><a href={`mailto:${email}`}>{email}</a></div>}
        {tel && <div><a href={`tel:${tel}`}>{tel}</a></div>}
      </div>
    </div>
  );
};

type HighlightedProfileContainerProps = {
  heading: string
  children: React.ReactNode
};

const HighlightedProfileContainer: React.FC<HighlightedProfileContainerProps> = (props) => {
  const { heading, children } = props;

  return (
    <Block type="secondary" className="HighlightedProfiles">
      <h2>
        {heading}
      </h2>
      {children}
    </Block>
  );
};

const HighlightedProfiles = HighlightedProfileContainer as typeof HighlightedProfileContainer & {
  Profile: typeof HighlightedProfile;
  Container: typeof HighlightedProfileContainer;
};
HighlightedProfiles.Profile = HighlightedProfile;
HighlightedProfiles.Container = HighlightedProfileContainer;

export default HighlightedProfiles;
